// extracted by css-extract-rspack-plugin
export default {"root":"MTrQG","border":"uz19W"};